import React from 'react'
import Text from '@component/Text/Text'
import {getLinkUrl, URL_ACCOUNT_TERM_CONDITIONS} from '@constant/url'

export const PrivacyTermEnglish = () => {
    return (
        <>
            <div className={'text-body1 text-gray02 dark:text-dark_gray02  px-[30px]'}>
                <Text className={'text-h2 text-gray01 dark:text-dark_gray01'}>PRIVACY POLICY</Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    <strong>Effective Date: August 08, 2019</strong>
                </Text>
                <Text className={'mt-[10px]'}>
                    <strong>Wizpace LTD</strong> (&quot;us&quot;, &quot;we&quot; or &quot;our&quot;) operates the{' '}
                    <strong>League of Traders</strong> mobile application. This Privacy Policy (“Privacy Policy” or
                    “Policy”) helps explain how we collect, use, store, and protect your information. This Policy sets
                    forth the conditions of privacy during your usage of the League of Traders mobile application and
                    any of its products or services (collectively, &quot;Mobile Application&quot; or
                    &quot;Service(s)&quot;). This Policy informs you of our disclosure of personal data when you use our
                    Service and the choices you have associated with that data. We use your personal data to provide and
                    improve the Service. By using the Service, you agree to the collection and use of information in
                    accordance with this Policy. If you do not agree with or are not comfortable with any aspect of this
                    Policy, you should discontinue access or use of our Services. Unless otherwise defined in this
                    Privacy Policy, terms used in this Privacy Policy have the same meanings as in our{' '}
                    <a href={getLinkUrl(URL_ACCOUNT_TERM_CONDITIONS)}>Terms and Conditions</a>.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 1 - PERSONAL INFORMATION COLLECTION
                </Text>
                <Text className={'mt-[10px]'}>
                    To ensure the best product for Users, we may collect your Usage Data when you use or register an
                    account on the League of Traders. Furthermore, we collect and/or receive several different types of
                    data for various purposes to provide and improve our Service to you.
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text className={'text-body1 text-gray02 dark:text-dark_gray02'}>
                        <strong>Information you provide:</strong> Certain types of Usage Data may be freely provided by
                        the User while using the application. For example, when a User manually inputs the details of
                        their API key, this data is then utilized to provide features such as total portfolio values,
                        League of Traders scoreboard ranking, and profit/loss over time. While using our Service, we may
                        ask you to provide us with certain personally identifiable information that can be used to
                        contact or identify your (&quot;Personal Data&quot;).
                        <br />
                        Personally, identifiable information may include, but is not limited to:
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Your Account Information:</strong> your API key, your social media account name, and
                        email address.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Your Products and Services:</strong> We retain the information voluntarily submitted by
                        you for the Service.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Your Application Program Interface (API) Key(s):</strong> We retain your API keys
                        inputted for the use of the Service.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Your Transactions:</strong> We may retain any record, histories, or metadata of your
                        cryptocurrency transactions. To monitor cryptocurrency transactions and provide you with account
                        balance information, as we store your API keys.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Automatically collected information:</strong> Usage Data may also be collected by the
                        application automatically for the purposes of improving the product. For example, debugging
                        information to help identify and address bugs may be compiled.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Metrics and Performance Data:</strong> We collect service-related, diagnostic, and
                        performance information. This includes high-level information about your activity (such as how
                        you use our Services and how you interact with others using our Services), and diagnostic,
                        crash, and performance logs and reports. With your API key information, we collect your account
                        balance every few seconds, trading history, and deposits and withdrawal history.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        <strong>Device and Connection Information:</strong> We collect device-specific information when
                        you download, access, or use our Service.
                    </Text>
                </div>
                <Text className={'mt-[10px]'}>
                    We may collect personal information that you disclose on our message boards, features, and our other
                    services. Any information that you disclose in those features becomes public information and may,
                    therefore, appear in public ways. If you do not want to reveal information to the public at large do
                    not post any information in those features.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 2 - PERSONAL INFORMATION USAGE
                </Text>
                <Text className={'mt-[10px]'}>League of Traders uses the collected data for various purposes:</Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text className={'text-body1 text-gray02 dark:text-dark_gray02'}>
                        To improve the content of our Mobile Application
                    </Text>
                    <Text className={'mt-[10px]'}>To provide and maintain the Service</Text>
                    <Text className={'mt-[10px]'}>To notify you about changes to our Service</Text>
                    <Text className={'mt-[10px]'}>
                        To allow you to participate in interactive features of our Service when you choose to do so
                    </Text>
                    <Text className={'mt-[10px]'}>To provide customer care and support</Text>
                    <Text className={'mt-[10px]'}>
                        To provide analysis or valuable information so that we can improve the Service
                    </Text>
                    <Text className={'mt-[10px]'}>To monitor the usage of the Service</Text>
                    <Text className={'mt-[10px]'}>To detect, prevent, and address technical issues.</Text>
                </div>
                <Text className={'mt-[10px]'}>
                    How we use the information we collect: Our primary purpose in collecting information is to help us
                    operate, provide, improve, customize, support, and market our Services. When you access the Service
                    by or through a mobile device, we may collect certain information automatically, including, but not
                    limited to, the type of mobile device you use, your mobile device unique ID, the IP address of your
                    mobile device, your mobile operating system, the type of mobile Internet browser you use, unique
                    device identifiers and other diagnostic data (&quot;Usage Data&quot;). We do not share any of your
                    personally identifiable or transactional information with any person or entity, other than as set
                    out in this policy. Specifically, your data may be used in the following ways:
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text className={'text-body1 text-gray02 dark:text-dark_gray02'}>
                        To provide League of Traders Services: We process your personal information to provide the
                        Services. For example, if you want to use our Service to view the ranking of your crypto
                        earnings in comparison to other traders, we require that you provide us with your API key. Also,
                        we use users’ data for generating users’ trading summary which includes profit earned
                        calculation. We cannot provide you with Services without such information.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        To provide Service communications: We may send administrative or account-related information to
                        you to keep you updated about our Services, inform you of relevant security issues or updates,
                        or provide other transaction-related information. Without such communications, you may not be
                        aware of important developments relating to your account that may affect how you can use our
                        Services.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        To provide customer service: We process your personal information when you contact us to resolve
                        any questions, disputes, or troubleshoot problems. Without processing your personal information
                        for such purposes, we cannot respond to your requests and ensure your uninterrupted use of the
                        Services.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        To ensure quality control: We process your personal information for quality control to make sure
                        we continue to provide you with accurate information.
                    </Text>
                </div>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 3 – SHARING YOUR INFORMATION
                </Text>
                <Text className={'mt-[10px]'}>
                    League of Traders will take all steps reasonably necessary to ensure that your data is treated
                    securely and in accordance with this Privacy Policy. No transfer of your Personal Data will take
                    place to an organization or a country unless there are adequate controls in place including the
                    security of your data and other personal information. The personal information displayed on a user’s
                    profile is not shared with anyone else. Furthermore, trading history and notifications on trades are
                    shown only to a user’s followers. What is to be shown is in the control of the user, the user can
                    delete their API key anytime and all their data will be removed from our services. We will not share
                    the personal information we hold about you except in the following circumstances:
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text className={'text-body1 text-gray02 dark:text-dark_gray02'}>
                        between and among League of Traders and our current and future parents, affiliates,
                        subsidiaries, and other companies under common control and ownership; and
                    </Text>
                    <Text className={'mt-[10px]'}>
                        with professional advisors, vendors, consultants, and other service providers, such as payment
                        service providers, IT hosting companies, other financial institutions and reference agencies who
                        need access to such information to carry out work on our behalf;
                    </Text>
                    <Text className={'mt-[10px]'}>
                        in connection with, or during negotiations of, any merger, sale of company assets, financing or
                        acquisition of all or a portion of League of Traders by another company;
                    </Text>
                    <Text className={'mt-[10px]'}>
                        in response to a request for information if we believe disclosure is in accordance with or
                        required by any applicable law or legal process, including lawful requests by public authorities
                        to meet national security or law enforcement requirements;
                    </Text>
                    <Text className={'mt-[10px]'}>
                        if we believe your actions are inconsistent with our user agreements or policies, or to protect
                        the rights, property, and safety of League of Traders or others.
                    </Text>
                </div>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 4 - DISCLOSURE OF DATA
                </Text>
                <Text className={'mt-[10px]'}>
                    Personal information is controlled by the user, and you can delete your API key anytime and all your
                    data will be removed from our servers. We strongly advise you to review the Privacy Policy of every
                    time you visit. From time to time, we may obtain information about you from third party sources as
                    required or permitted by applicable law, such as public databases, resellers and channel partners,
                    joint marketing partners, and social media platforms. If you elect to proceed with a
                    transaction/service that involves the services of a third-party service provider, then your
                    information may become subject to the laws of the jurisdiction(s) in which that service provider or
                    its facilities are located. Once you leave our Mobile Application or are redirected to a
                    third-party, you are no longer governed by this Privacy Policy or our Terms of Service. We have no
                    control over and assume no responsibility for the content, privacy policies or practices of any
                    third party sites or services.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>Legal Requirements</Text>
                <Text className={'mt-[10px]'}>
                    League of Traders may disclose your Personal Data in the good faith belief that such action is
                    necessary to:
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text className={'text-body1 text-gray02 dark:text-dark_gray02'}>
                        To comply with a legal obligation
                    </Text>
                    <Text className={'mt-[10px]'}>
                        To protect and defend the rights or property of League of Traders
                    </Text>
                    <Text className={'mt-[10px]'}>
                        To prevent or investigate possible wrongdoing in connection with the Service
                    </Text>
                    <Text className={'mt-[10px]'}>
                        To protect the personal safety of users of the Service or the public
                    </Text>
                    <Text className={'mt-[10px]'}>To protect against legal liability</Text>
                </div>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>
                    Retention of Personal Information
                </Text>
                <Text className={'mt-[10px]'}>
                    We store the information we collect on you for as long as is necessary for the purpose(s) for which
                    we originally collected it, or for other legitimate business purposes, including to meet our legal,
                    regulatory, or other compliance obligations. The period for which we will retain personal
                    information will vary depending on the purposes that it was collected for, as well as the
                    requirements of any applicable law or regulation. If you have an account with League of Traders, we
                    will store your personal information for as long as you maintain that account, and after you cease
                    holding an account, for as long as we are required to by-laws and regulations that are applicable to
                    us. Your Personal Data is kept for the time necessary to provide services and features to the User.
                    At any time, the User may request to have their data be suspended or removed. Upon request, we will
                    remove the data specified.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 5 - SECURITY OF DATA
                </Text>
                <Text className={'mt-[10px]'}>
                    We understand how important your privacy is, which is why League of Traders maintains (and requires
                    its service providers to maintain) appropriate physical, technical and administrative safeguards to
                    protect the security and confidentiality of the personal information you entrust to us. To protect
                    your personal information, we take reasonable precautions and follow industry best practices to make
                    sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed. We protect
                    your personal information by using data security technology and using tools such as firewalls and
                    data encryption. We also require that you use a personal username and password every time you access
                    your account online. As provided in the relevant League of Trader’s{' '}
                    <a href="/terms">terms and conditions</a>, terms of business and/or terms of use, you must not share
                    your password with anyone else. We restrict access to personal information at our offices so that
                    only officers and/or employees with a legitimate business purpose can access it. However, we cannot
                    guarantee that loss, misuse, unauthorized acquisition, or alteration of your data will not occur.
                    Please recognize that you play a vital role in protecting your own personal information. When
                    registering with our Services, it is important to choose a password of sufficient length and
                    complexity, to not reveal this password to any third parties, and to immediately notify us if you
                    become aware of any unauthorized access to or use of your account. The security of your Personal
                    Information is important to us, but remember that no method of transmission over the Internet, or
                    method of electronic storage is not completely secure. Furthermore, we cannot ensure or warrant the
                    security or confidentiality of the information you transmit to us or receive from us by Internet or
                    wireless connection, including email, phone, or SMS, since we have no way of protecting that
                    information once it leaves and until it reaches us. While we strive to use commercially acceptable
                    means to protect your Personal Information, we cannot guarantee its absolute security.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>Service Providers</Text>
                <Text className={'mt-[10px]'}>
                    We may employ third party companies and individuals to facilitate our Service (&quot;Service
                    Providers&quot;), to provide the Service on our behalf, to perform Service-related services or to
                    assist us in analyzing how our Service is used. These third parties have access to your Personal
                    Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any
                    other purpose.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>Links To Other Sites</Text>
                <Text className={'mt-[10px]'}>
                    Our Service may contain links to other sites that are not operated by us. If you click on a third
                    party link, you will be directed to that third party&apos;s site. We strongly advise you to review
                    the Privacy Policy of every site you visit. We have no control over and assume no responsibility for
                    the content, privacy policies or practices of any third party sites or services.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 6 - PERSONAL INFORMATION RIGHTS
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>
                    Rights of access, correction, and deletion
                </Text>
                <Text className={'mt-[10px]'}>
                    You have a right of access to the personal information that we hold about you, and to some related
                    information. You can also require any inaccurate personal information to be corrected or deleted.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>Right to object</Text>
                <Text className={'mt-[10px]'}>
                    You can object to our use of your personal information for direct marketing purposes at any time and
                    you may have the right to object to our processing of some or all of your personal information (and
                    require them to be deleted) in some other circumstances.
                </Text>
                <Text className={'mt-[10px]'}>If you wish to exercise any of these rights, please contact us.</Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 7 - AGE OF CONSENT
                </Text>
                <Text className={'mt-[10px]'}>
                    By using League of Traders, you represent that you are at least the age of majority in your state or
                    province of residence; or that you are the age of majority in your state or province of residence
                    and you have given us your consent to allow any of your minor dependents to use this Mobile
                    Application. If you are a minor in your state or province of residence, you should not download to
                    use our Mobile Application nor provide any personal information to us. Please notify us if you know
                    of any individuals under the age of 18 using our Services so we can take action to prevent access to
                    our Services. We will also take steps to delete the information as soon as possible.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 8 - CHANGES TO THE PRIVACY POLICY
                </Text>
                <Text className={'mt-[10px]'}>
                    We reserve the right to modify this Privacy Policy at any time, so please review it frequently.
                    Changes and clarifications will take effect immediately upon their posting on the Policy. If we make
                    material changes to this Policy, we will notify you here that it has been updated, so that you are
                    aware of what information we collect, how we use it, and under what circumstances, if any, we use
                    and/or disclose it. If our service is acquired or merged with another company, your information may
                    be transferred to the new owners so that we may continue to sell products to you.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    SECTION 9 - QUESTIONS AND CONTACT INFORMATION
                </Text>
                <Text className={'mt-[10px]'}>
                    If you would like to: access, correct, amend or delete any personal information we have about you,
                    register a complaint, or simply want more information contact us at:{' '}
                    <a href="mailto:support@leagueoftraders.io">support@leagueoftraders.io</a>. Please include your
                    name, and mailing or email address.
                </Text>
            </div>
        </>
    )
}
